import { render, staticRenderFns } from "./jrfw.vue?vue&type=template&id=62aa44c8&scoped=true"
import script from "./jrfw.vue?vue&type=script&lang=js"
export * from "./jrfw.vue?vue&type=script&lang=js"
import style0 from "./jrfw.vue?vue&type=style&index=0&id=62aa44c8&prod&lang=css"
import style1 from "./jrfw.vue?vue&type=style&index=1&id=62aa44c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62aa44c8",
  null
  
)

export default component.exports